import React from "react";

const MessageSendModal = ({
  subHeading,
  onClose,
  heading,
  SendEmail,
  SendWhatsapp,
  SendSMS,
}) => {
  return (
    <div className="BillBar-modal">
      <div className="BillBar-modal-content">
        <div className="BillBar-modal-header">
          <h2>{heading}</h2>
          <button onClick={onClose} className="BillBar-modal-close">
            ✖
          </button>
        </div>
        <p className="mt-2">{subHeading}</p>
        <div className="BillBar-modal-buttons">
          <button
            onClick={SendSMS}
            className="BillBar-modal-button BillBar-modal-format1"
          >
            Send SMS
          </button>
          <button onClick={SendEmail} className="BillBar-modal-close-btn">
            Send EMAIL
          </button>

          <button
            onClick={SendWhatsapp}
            className="BillBar-modal-button BillBar-modal-sendmsg"
          >
            Send Whatsapp
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageSendModal;
